import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B132B] px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-xl overflow-hidden shadow-lg mb-4 ring-1 ring-white/10">
            <img src="/goat-logo.png" alt="GOAT Marketing Group" className="w-full h-full object-cover scale-[1.7]" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-white">Admin Login</h1>
          <p className="text-sm text-slate-400 mt-1">GOAT Personal Injury Network</p>
        </div>

        <form onSubmit={submit} className="bg-[#111D4A] border border-white/10 rounded-2xl p-6 space-y-4">
          {error && (
            <div data-testid="login-error" className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <div>
            <label className="text-xs font-semibold text-slate-300 uppercase tracking-wide">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1.5 w-full bg-[#1A275B] border border-white/15 rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-slate-400 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="admin@goatmktg.com"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-300 uppercase tracking-wide">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1.5 w-full bg-[#1A275B] border border-white/15 rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-slate-400 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
